import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import FormattedMessage from 'I18n/components/FormattedMessage';

// TODO add translations for this
import { jsx as _jsx } from "react/jsx-runtime";
function ApprovalLoading() {
  return /*#__PURE__*/_jsx(LoadingButton, {
    loading: true,
    use: "primary",
    role: "progressbar",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.modal.action.REQUEST"
    })
  });
}
export default ApprovalLoading;